module.exports = __webpack_public_path__ + "img/SOWTA_Bright_1k.0927852a.png";